// Override Settings
var bcSfFilterSettings = {
  general: {
      limit: bcSfFilterConfig.custom.products_per_page,
      // Optional
      loadProductFirst: false,
      styleScrollToTop: 'style2',
      defaultDisplay: bcSfFilterConfig.custom.layout,
  },
};

var bcSfFilterTemplate = {
  'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',

  // Grid Template
  'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
  'soldOutLabelGridHtml': ' <span class="product-price__sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
  'productGridItemHtml': '<div class="grid__item {{itemGridWidthClass}}">' +
                              '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                              '<div class="grid-view-item {{itemSoldOutClass}} product-card">' +
                                  '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{itemUrl}}">' +
                                      '<span class="visually-hidden">{{itemTitle}}</span>' +
                                  '</a>' +
                                  '{{imageStyle}}' +
                                  '{{itemImages}}' +
                                  '<div class="h4 grid-view-item__title">{{itemTitle}}</div>' +
                                  '{{itemPrice}}' +
                  '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                              '</div>' +
                '<div class="button-wrapper" style="text-align: center; display: block;">' +
                  '<input type="button" value="-" class="qtyminus" field="quantity"  />'+
                  '<input type="text" name="quantity" value="1" class="qty" class="qty-add-to-cart" id="product-quantity-{{itemId}}" data-product="{{itemFirstVariantId}}" style="width: 14%, margin-top: 10px, margin-bottom: 10px;" readonly/>' +
                  '<input type="button" value="+" class="qtyplus" field="quantity" />' +
                                  '<button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit btn--secondary-accent hp-submit" data-handle="{{itemHandle}}">' +
                                    '<span class="AddToCartText-product-template"><ly-as-14626642>Add to cart</ly-as-14626642></span>' +
                                  '</button>' +
                '</div>' +
                          '</div>',

  // List Template
  'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
  'vendorMediumListHtml': '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
  'saleLabelListHtml': '<div class="list-view-item__on-sale">' + bcSfFilterConfig.label.sale + '</div>',
  'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + bcSfFilterConfig.label.sold_out + '</div>',
  'productListItemHtml':  '<li href="{{itemUrl}}" class="list-view-item">' +
                              '<div class="product-card product-card--list">' +
                                  '<a class="full-width-link" href="{{itemUrl}}">' +
                                      '<span class="visually-hidden">{{itemTitle}}</span>' +
                                  '</a>' +
                                  '<div class="list-view-item__link">' +
                                      '<div class="list-view-item__image-column">' +
                                          '<div class="list-view-item__image-wrapper">' +
                                              '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                          '</div>' +
                                      '</div>' +
                                      '<div class="list-view-item__title-column">' +
                                          '<div class="list-view-item__title" aria-hidden="true">{{itemTitle}}</div>' +
                                          '{{itemSaleLabel}}' +
                                          '{{itemMediumVendor}}' +
                                          '{{itemSoldOutLabel}}' +
                                      '</div>' +
                                      '<div class="list-view-item__price-column">{{itemPrice}}</div>' +
                                  '</div>' +
                              '</div>' +
                          '</li>',

  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
  'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></a></li>',
  'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
  'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',

  // Sorting Template
  'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function(data) {
/*** Prepare data ***/
var images = data.images_info;
// Displaying price base on the policy of Shopify, have to multiple by 100
var soldOut = !data.available; // Check a product is out of stock
var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
var priceVaries = data.price_min != data.price_max; // Check a product has many prices
// Get First Variant (selected_or_first_available_variant)
var firstVariant = data['variants'][0];
if (getParam('variant') !== null && getParam('variant') != '') {
  var paramVariant = data.variants.filter(function(e) {
    return e.id == getParam('variant');
  });
  if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
} else {
  for (var i = 0; i < data['variants'].length; i++) {
    if (data['variants'][i].available) {
      firstVariant = data['variants'][i];
      break;
    }
  }
}
/*** End Prepare data ***/

// Get Template
var itemHtml = bcSfFilterTemplate.productGridItemHtml;

// Add a specific class for grid item
var itemGridWidthClass = '';
var imageSize = '600x600';
switch (bcSfFilterConfig.custom.products_per_row) {
  case 2:
    itemGridWidthClass = 'medium-up--one-half';
    imageSize = '540x600';
    break;
  case 3:
    itemGridWidthClass = 'small--one-half medium-up--one-third';
    imageSize = '345x550';
    break;
  case 4:
    itemGridWidthClass = 'small--one-half medium-up--one-quarter';
    imageSize = '250x';
    break;
  case 5:
    itemGridWidthClass = 'small--one-half medium-up--one-fifth';
    imageSize = '195x';
    break;
}
itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

// Add soldOut class
var itemSoldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

// Add soldOut label
var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : '';
itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

var imgId = 'ProductCardImage-'+ data.id ;
var wrapperId = 'ProductCardImageWrapper-'+ data.id ;

// Build Image style
var imageStyle = buildImageStyle(data);
itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

// Add Images
var aspect_ratio = '';
var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
itemImagesHtml += '<div style="padding-top:';
if (images.length > 0) {
  aspect_ratio = images[0]['width'] / images[0]['height'];
  itemImagesHtml += 1 / aspect_ratio * 100;
} else {
  itemImagesHtml += 100;
}
itemImagesHtml += '%;">';
itemImagesHtml += '<img id="' + imgId + '" ' +
  'class="grid-view-item__image lazyload" ' +
  'src="' + this.getFeaturedImage(images, '300x300') + '" ' +
  'data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' +
  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
  'data-aspectratio="' + aspect_ratio + '" ' +
  'data-sizes="auto" ' +
  'alt="{{itemTitle}}">';
itemImagesHtml += '</div>';
itemImagesHtml += '</div>';

var image_size = bcSfFilterConfig.custom.max_height + 'x' + bcSfFilterConfig.custom.max_height;
var max_width = images.length > 0 ? bcSfFilterConfig.custom.max_height * aspect_ratio : 0;
itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + this.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

// Add Vendor
var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml : '';
itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

// Add Price
var itemPriceHtml = buildPrice(data, onSale, priceVaries);
itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

// Add data json
var self = this;
var itemJson = {
  "id": data.id,
  "title": data.title,
  "handle": data.handle,
  "vendor": data.vendor,
  "variants": data.variants,
  "url": self.buildProductItemUrl(data),
  "options_with_values": data.options_with_values,
  "images": data.images,
  "available": data.available,
  "price_min": data.price_min,
  "price_max": data.price_max,
  "compare_at_price_min": data.compare_at_price_min,
  "compare_at_price_max": data.compare_at_price_max
};
itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

// Add main attribute
itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
var langId = getLangId();
var title = data.title;
var metaTitle = this.getProductMetafield( data , langId , 'title' );;
if( metaTitle !== null)
  title = metaTitle;
itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
itemHtml = itemHtml.replace(/{{itemFirstVariantId}}/g, firstVariant.id);
itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

return itemHtml;
}

// Build Image style
function buildImageStyle(data) {
var images = data.images_info;
var imgId = 'ProductCardImage-'+ data.id ;
var wrapperId = 'ProductCardImageWrapper-'+ data.id ;
var imageStyle = '';
if (images.length > 0) {
  var image = images[0];
  var width = bcSfFilterConfig.custom.max_height;
  var height = bcSfFilterConfig.custom.max_height;
  var aspect_ratio = image.width / image.height;
  var small_style = true;
  var container_aspect_ratio = width * 1.0 / height;

  if (image.aspect_ratio < 1.0) {
    var maximum_width = height * aspect_ratio;
    if (image.height <= height) {
      var maximum_height = image.height;
      maximum_width = image.width;
    } else {
      var maximum_height = height;
    }
  } else if (aspect_ratio < container_aspect_ratio) {
    var maximum_height = height / aspect_ratio;
    if (image.height <= height) {
      var maximum_height = image.height;
      var maximum_width = image.width;
    } else {
      var maximum_height = height;
      var maximum_width = height * aspect_ratio;
    }
  } else {
    var maximum_height = height / aspect_ratio;
    if (image.width <= width) {
      maximum_height = image.height;
      var maximum_width = image.width
    } else {
      var maximum_width = width;
      maximum_height = maximum_width / aspect_ratio;
    }
  }

  imageStyle += '<style>';
  if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
  imageStyle += '#' + imgId + ' {' +
    'max-width: ' + maximum_width + 'px;' +
    'max-height: ' + maximum_height + 'px;' +
    '}' +
    '#' + wrapperId + ' {' +
    'max-width: ' + maximum_width + 'px;' +
    'max-height: ' + maximum_height + 'px;' +
    '}';
  if (small_style) imageStyle += '}';

  if (small_style) {
    if (aspect_ratio < 1) {
      maximum_width = 750 * aspect_ratio;
    } else {
      if (image.width < 750) {
        maximum_width = image.width;
      } else {
        maximum_width = 750;
      }
    }
    imageStyle += '@media screen and (max-width: 749px) {'
    imageStyle += '#' + imgId + ' {' +
      'max-width: ' + maximum_width + 'px;' +
      'max-height: 750px;' +
      '}' +
      '#' + wrapperId + ' {' +
      'max-width: ' + maximum_width + 'px;' +
      '}';
    imageStyle += '}';
  }
  imageStyle += '</style>';
}
return imageStyle;
}

BCSfFilter.prototype.buildProductListItem = function(data) {
/*** Prepare data ***/
var images = data.images_info;
// Displaying price base on the policy of Shopify, have to multiple by 100
var soldOut = !data.available; // Check a product is out of stock
var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
var priceVaries = data.price_min != data.price_max; // Check a product has many prices
// Get First Variant (selected_or_first_available_variant)
var firstVariant = data['variants'][0];
if (getParam('variant') !== null && getParam('variant') != '') {
  var paramVariant = data.variants.filter(function(e) {
    return e.id == getParam('variant');
  });
  if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
} else {
  for (var i = 0; i < data['variants'].length; i++) {
    if (data['variants'][i].available) {
      firstVariant = data['variants'][i];
      break;
    }
  }
}
/*** End Prepare data ***/

// Get Template
var itemHtml = bcSfFilterTemplate.productListItemHtml;

// Add onSale label
var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

// Add soldOut label
var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

// Add Thumbnail
var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

// Add Vendor
var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

// Add Price
var itemPriceHtml = buildPrice(data, onSale, priceVaries);
itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

// Add main attribute
var langId = getLangId();
var title = data.title;
var metaTitle = this.getProductMetafield( data , langId , 'title' );
if( metaTitle !== null)
  title = metaTitle;
itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

return itemHtml;
}

function buildPrice(data, onSale, priceVaries) {
var priceHtml = '',
  onSaleClass = onSale ? ' price--on-sale' : '';

priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
if (bcSfFilterConfig.custom.vendor_enable) {
  priceHtml += '<div class="price__vendor">';
  priceHtml += '<dt>';
  priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.vendor + '</span>';
  priceHtml += '</dt>';
  priceHtml += '<dd>';
  priceHtml += data.vendor;
  priceHtml += '</dd>';
  priceHtml += '</div>';
}
priceHtml += '<div class="price__regular">';
priceHtml += '<dt>';
priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.regular_price + '</span>';
priceHtml += '</dt>';
priceHtml += '<dd>';
if (data.available) {
  priceHtml += '<span class="price-item price-item--regular" data-regular-price >';
  if (onSale) {
    priceHtml += bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat);
  } else {
    priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
  }
} else {
  priceHtml += '<span class="price-item price-item--regular soldout_line" data-regular-price>';
  priceHtml += bcSfFilterConfig.label.sold_out;
}
priceHtml += '</span>';
priceHtml += '</dd>';
priceHtml += '</div>';
if (data.available) {
priceHtml += '<div class="price__sale">';
priceHtml += '<dt>';
priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.sale_price + '</span>';
priceHtml += '</dt>';
priceHtml += '<dd>';
priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
priceHtml += '</span> ';
priceHtml += '<span class="price-item__label" aria-hidden="true"> ' + bcSfFilterConfig.label.sale + '</span>';
priceHtml += '</dd>';
priceHtml += '</div>';
}
priceHtml += '</dl>';

return priceHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
// Get page info
var currentPage = parseInt(this.queryParams.page);
var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

// If it has only one page, clear Pagination
if (totalPage == 1) {
  jQ(this.selector.pagination).html('');
  return false;
}

if (this.getSettingValue('general.paginationType') == 'default') {
  var paginationHtml = bcSfFilterTemplate.paginateHtml;

  // Build Previous
  var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
  previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
  paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

  // Build Next
  var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
  nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
  paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

  // Build page items
  var currentPage = bcSfFilterConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
  paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

  jQ(this.selector.pagination).html(paginationHtml);
}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
  jQ(this.selector.topSorting).html('');

  var sortingArr = this.getSortingList();
  if (sortingArr) {
    // Build content
    var sortingItemsHtml = '';
    for (var k in sortingArr) {
      sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
    }
    var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    jQ(this.selector.topSorting).html(html);

    // Set current value
    jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
  }
}
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
var itemHtml = '<span>View As </span>';
itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
jQ(this.selector.topDisplayType).html(itemHtml);

// Active current display type
jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
if (this.queryParams.display == 'list') {
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
} else if (this.queryParams.display == 'grid') {
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /* start-initialize-bc-al */
  var self = this;
  var alEnable = true;
  if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
    alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
  }
  if (alEnable === true && typeof BCActionList !== 'undefined') {
      if (typeof bcActionList === 'undefined') {
          bcActionList = new BCActionList();
      }else{
        if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
            bcActionList.initFlag = false;
            bcActionList.alInit(bcSfFilterParams, bcAlParams);
        } else {
            bcActionList.alInit();
        }
      }
  }
  /* end-initialize-bc-al */
var productSelector = jQ(this.selector.products);
if (this.queryParams.display == 'list') {
  if (productSelector.children('.list-view-items').length == 0) {
    productSelector.children().wrapAll('<ul class="list-view-items"/>');
  }
  productSelector.removeClass('grid grid--uniform grid--view-items');
} else {
  if (productSelector.children('.list-view-items').length > 0) {
    productSelector.children('.list-view-items').children().unwrap();
  }
  productSelector.addClass('grid grid--uniform grid--view-items');
}


Currency.format = 'money_with_currency_format';
var shopCurrency = 'HKD';
/* Sometimes merchants change their shop currency, let's tell our JavaScript file */
Currency.moneyFormats[shopCurrency].money_with_currency_format = "HK${{amount}}";
Currency.moneyFormats[shopCurrency].money_format = "${{amount}}";

/* Default currency */
var defaultCurrency = 'HKD';

/* Cookie currency */
var cookieCurrency = Currency.cookie.read();
/* Fix for customer account pages */
jQuery('span.money span.money').each(function() {
  jQuery(this).parents('span.money').removeClass('money');
});
/* Saving the current price */
jQuery('span.money').each(function() {
  jQuery(this).attr('data-currency-HKD', jQuery(this).html());
});
// If there's no cookie.
if (cookieCurrency == null) {
  if (shopCurrency !== defaultCurrency) {
    Currency.convertAll(shopCurrency, defaultCurrency);
  }
  else {
    Currency.currentCurrency = defaultCurrency;
  }
}
// If the cookie value does not correspond to any value in the currency dropdown.
else if (jQuery('[name=currencies]').length && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
  Currency.currentCurrency = shopCurrency;
  Currency.cookie.write(shopCurrency);
}
else if (cookieCurrency === shopCurrency) {
  Currency.currentCurrency = shopCurrency;
}
else {
  Currency.convertAll(shopCurrency, cookieCurrency);
  setTimeout(function() {Currency.convertAll(shopCurrency, cookieCurrency);}, 1500);
}
jQuery('[name=currencies]').val(Currency.currentCurrency).change(function() {
  var newCurrency = jQuery(this).val();
  Currency.convertAll(Currency.currentCurrency, newCurrency);
  jQuery('.selected-currency').text(Currency.currentCurrency);
});
var original_selectCallback = window.selectCallback;
var selectCallback = function(variant, selector) {
  original_selectCallback(variant, selector);
  Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
  jQuery('.selected-currency').text(Currency.currentCurrency);
};
$('body').on('ajaxCart.afterCartLoad', function(cart) {
  Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
  jQuery('.selected-currency').text(Currency.currentCurrency);  
});
jQuery('.selected-currency').text(Currency.currentCurrency);

// Add to cart
$(document).ready(function () {
  $(".qtyminus").click(function () {
      var qty_field = $(this).next(".qty");

      if (parseInt(qty_field.val())) {
          qty_field.val(qty_field.val() - 1)
      } else {
          qty_field.val(0)
      }
  })
  $(".qtyplus").click(function () {
      var qty_field = $(this).prev(".qty");

      if (parseInt(qty_field.val())) {
          qty_field.val(parseInt(qty_field.val()) + 1)
      } else {
          qty_field.val(1)
      }
  })
  $(".hp-submit").click(function (e) {
      e.preventDefault();
      var p_handle = $(this).data("handle");
      var limits = minMaxify.getLimitsFor({
          handle: p_handle
      });
      var qty_field = $(this).siblings(".qty");
      var span = $(this).children("span");
      console.log(limits);
      console.log(p_handle);
      var add = true;
      $.getJSON("/cart.js")
          .done(function (response) {
              // console.log(response);
              // console.log(response.items[0].handle);
              // console.log(response.items[1].handle);
              // console.log(response.items);
              // for (var i = 0; i < items_count; i++)
              $.each(response.items, function (index, value) {
                  console.log("index", index);
                  console.log("value", value);
                  //   console.log("item", item.handle);
                  // if item exists get how many of them are there
                  // if set add to false if quantity missmatch (quantity > limit)
                  if (value.handle == p_handle && limits.max != 0) {
                      console.log(value.handle);
                      if (value.quantity >= limits.max) {
                          add = false;
                          console.log(span);
                          span.html("ITEM LIMIT REACHED");
                      }
                      // else if (value.quantity >= item.variant.inventory_quantity)  {
                      //     add = false;
                      //     console.log(span);
                      //     span.html("ITEM LIMIT REACHED");
                      // }
                  }
                  // }

              })
              if (add) {
                  console.log(span);
                  span.html("ADDING...");
                  $.ajax({
                      method: "POST",
                      url: "/cart/add.js",
                      dataType: "json",
                      data: {
                          quantity: parseInt(qty_field.val()),
                          id: qty_field.data("product")
                      }
                  }).done(function () {
                      $.getJSON("/cart.js")
                          .done(function (response) {
                              span.html("THANK YOU!")
                              $("#CartCount").show();
                              $("#CartCount span").text(response.item_count);
                              setTimeout(() => {
                                  span.html("ADD TO CART")
                              }, 2000);

                          });
                  }).fail(function () {
                      console.log("failed");
                      console.log(span);
                      span.html("ITEM LIMIT REACHED");
                      location.reload();
                      // setTimeout(() => {
                      //   span.html("ADD TO CART")
                      // }, 2000);
                  })
              }

          });
  })
});
};

// Add this function to bc-sf-filter.js
function getLangId() {
var lang = $('#ly-languages-switcher option:selected').val();
  // if (lang == 'ly33580') lang = 'langshop';
  return lang;
}

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
var totalProduct = '';
if (data.total_product == 1) {
  totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
} else {
  totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
}
jQ('#bc-sf-filter-total-product').html(totalProduct);
var langifyTranslatableSelector = jQ(this.getSelector('filterTree')).find('.bc-sf-filter-option-value');
langifyTranslatableSelector.addClass('translatable');
!function(){var e=function(e){var t={exports:{}};return e.call(t.exports,t,t.exports),t.exports};e(function(){"use strict";window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}()});(function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.triggerEvent("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.triggerEvent("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.triggerEvent("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.triggerEvent("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.triggerEvent("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);


}


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; } return data };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
